import styled from 'styled-components';

import { media } from 'utils/detection';
import P from 'components/P';

const Paragraph1 = styled(P)`
  color: ${props => props.theme.textSemiDark};
  margin: 48px 0 0 0;

  ${media.medium`
    margin: 61px 0 0 0;
  `}
`;

Paragraph1.defaultProps = {
  big: true,
};

export default Paragraph1;